import makeList from './makeList.js'

let viewFloor = '旧放球棟'

let params = [
  {
    name: 'syowa',
    locations: [
      { description: '放球棟',
        file: './data/I19a.JPG',
        rotation: -13.451937697591845,
        link: [
          {
            file: './data/04c_R0010657.JPG',
            position: [ -4834.092756402735, -314.0749416889021, -1203.3488964838214 ],
          },
          {
            file: './data/04_R0010655.JPG',
            position: [ -4075.380874628075, -150.72781327306177, -2881.416048680442 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 816.0919540229885, 514.6871008939975 ],
          syowaZoom: [ 320.51282051282055, 513.0000000000001 ],
        },
      },
      { description: '放球デッキ',
        file: './data/04c_R0010657.JPG',
        rotation: 25.86917529649397,
        link: [
          {
            file: './data/I19a.JPG',
            position: [ 2785.8095249804455, 163.51003971889176, 4136.870511528891 ],
          },
          {
            file: './data/04_R0010655.JPG',
            position: [ -2125.922642650053, -647.5779265850292, -4469.589703322783 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 816.0919540229885, 514.6871008939975 ],
          syowaZoom: [ 469.2307692307693, 495.0512820512821 ],
        },
      },
    ],
  },
]

export default makeList(params,viewFloor)
